export const GET_DICTIONARY_COMPANY_BRANCHES = Symbol('GET_DICTIONARY_COMPANY_BRANCHES');
export const GET_DICTIONARY_COMPANY_BRANCHES_REQUEST = Symbol('GET_DICTIONARY_COMPANY_BRANCHES_REQUEST');
export const GET_DICTIONARY_COMPANY_BRANCHES_SUCCESS = Symbol('GET_DICTIONARY_COMPANY_BRANCHES_SUCCESS');
export const GET_DICTIONARY_COMPANY_BRANCHES_ERROR = Symbol('GET_DICTIONARY_COMPANY_BRANCHES_ERROR');

